import types from './types';
import {
    CALL_API
} from 'redux-api-middleware';

const apiUrl = '/api/results';

export function fetchResults() {
    return {
        [CALL_API]: {
            endpoint: apiUrl,
            method: 'GET',
            types: types.LOAD_RESULTS.all
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/result.js